export const getMoreInfo = (props)=>{
    if (!props.length) return undefined;
    const moreInfo = [];
    props?.forEach(({ title , content =''  })=>{
        if (title) moreInfo.push({
            content: title
        });
        moreInfo.push({
            content
        });
    });
    return moreInfo;
};
export const productCardCirRxjsConverter = (props)=>{
    const data = props.props ?? props.data ?? {};
    const { title ='' , subtitle ='' , productType , link ={
        href: ''
    } , image ={
        src: ''
    } , secondaryImage ={
        src: ''
    } , config , price , reviews , icons , descriptions =[] , moreInfo =[] , tag , upside , promotion , promo , ldjson  } = data;
    const ldjsonScript = ldjson && 'scripts' in ldjson ? ldjson : {
        scripts: [
            ldjson
        ]
    };
    const from = price?.from ?? config?.literals?.from;
    return {
        ...data,
        config: {
            ...data.config,
            literals: {
                fromCaption: from,
                moreInfo: config?.literals?.moreInfo,
                summary: config?.literals?.summary,
                priceCaption: price?.caption,
                excelent: reviews?.content,
                good: reviews?.content,
                veryGood: reviews?.content
            },
            deal: config?.deal,
            safe: config?.safe,
            icon: !!config?.icon,
            iconName: config?.icon,
            product: config?.product,
            rating: config?.rating,
            soldOut: config?.soldOut ?? props.soldOut,
            showSubtitleFirst: true
        },
        image,
        secondaryImage,
        link,
        title,
        subtitle: subtitle,
        detail: productType,
        descriptions: descriptions.flatMap((x)=>x.content ?? ''),
        moreInfo: getMoreInfo(moreInfo),
        price: {
            market_value: price?.market_value,
            value: price?.value,
            from: !!from,
            discount: price?.discount,
            caption: !!price?.caption
        },
        icons,
        tag,
        upside,
        promotion: promotion ?? promo,
        reviews: reviews?.number,
        ldjson: ldjsonScript
    };
};

//# sourceMappingURL=converter.js.map